import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { Typography } from "@mui/material";
import { fetchSalesSummary } from "../services/dashboardService";

const COLORS = ['#8b8fff', '#b1addf', '#3f3f8f'];

interface SalesPieChartProps {
  month: number | "";
  year: number | "";
}

const SalesPieChart: React.FC<SalesPieChartProps> = ({ month, year }) => {
  const [chartData, setChartData] = useState<{ name: string; value: number }[]>([]);

  useEffect(() => {
    const loadChartData = async () => {
      try {
        if (typeof month === "number" && typeof year === "number") {
          const response = await fetchSalesSummary(month, year);

          const rawData = response.data?.data || [];

          const transformed = rawData.map((item: any) => ({
            name: item.customer ?? "Unknown",
            value: item.amount ?? 0,
          }));

          setChartData(transformed);
        }
      } catch (error) {
        console.error("Failed to load sales summary:", error);
        setChartData([]);
      }
    };

    loadChartData();
  }, [month, year]);

  return (
    <div className="p-4 bg-white rounded-lg shadow-md w-full max-w-sm">
      <Typography variant="subtitle1" mb={3} fontWeight={500}>
        Revenue Report
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            // label={({ name, value }) =>
            //   `${name}: ₹${value.toLocaleString("en-IN")}`
            // }
          >
            {chartData.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" align="center" iconType="square" />
          <Tooltip
            formatter={(value: number) =>
              `₹${value.toLocaleString("en-IN")}`
            }
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesPieChart;
